import React from 'react'
import { Input, InputCheck, SelectAnimalFetchInput, SelectInput } from 'src/components'
import { montaTypeOptions } from 'src/constants/montaType'
import { formatDateToInputValue } from 'src/utils'
import { useFormContext } from 'react-hook-form'
import { FormattedOption } from 'src/dto/animal.dto'
import { formParams } from '../..'
import { useStyles } from '../../styles'

interface ReproductionSectionProps {
  useDateInterval: boolean
  handleToggleDateInterval: () => void
}

export const ReproductionSection: React.FC<ReproductionSectionProps> = ({
  useDateInterval,
  handleToggleDateInterval
}) => {
  const style = useStyles()
  const {
    watch,
    setValue,
    clearErrors,
    setError,
    formState: { errors }
  } = useFormContext<formParams>()

  const today = new Date().toISOString().split('T')[0]

  const validateDateNotFuture = (value: string, fieldName: string, fieldLabel: string) => {
    const selectedDate = new Date(value)
    const todayDate = new Date(today)

    if (selectedDate > todayDate) {
      setError(fieldName as any, { message: `${fieldLabel} não pode ser superior à data de hoje` })
      return false
    }
    return true
  }

  return (
    <section className={`${style.section} ${style.reproductionSection}`}>
      <h2 className={style.sectionTitle}>Detalhes da Reprodução</h2>
      <div className={style.reproductionInfoContainer}>
        <div className={`${style.infoGrid} ${useDateInterval ? style.singleColumnGrid : ''}`}>
          <div className={style.formControl}>
            <SelectInput
              label='Tipo de reprodução'
              value={watch('pregnancyDiagnosis.tipoReproducao') || ''}
              options={montaTypeOptions}
              selectBy='id'
              showBy={['value']}
              placeholder='Selecionar tipo de reprodução'
              onChange={(option: any) => {
                setValue('pregnancyDiagnosis.tipoReproducao', option?.id || '', { shouldDirty: true })
              }}
            />
          </div>

          {!useDateInterval && (
            <div className={style.formControl}>
              <Input
                type='date'
                max={today}
                label='Data'
                id='dataInicial'
                value={formatDateToInputValue(watch('pregnancyDiagnosis.dataInicial'))}
                error={errors?.pregnancyDiagnosis?.dataInicial?.message}
                onChange={(value: string) => {
                  if (validateDateNotFuture(value, 'pregnancyDiagnosis.dataInicial', 'Data')) {
                    clearErrors('pregnancyDiagnosis.dataInicial')
                  }
                  setValue('pregnancyDiagnosis.dataInicial', value, { shouldDirty: true })
                }}
              />
            </div>
          )}
        </div>

        <div className={style.formControl}>
          <InputCheck
            id='intervalo_data_cobertura'
            type='checkbox'
            name='date_interval'
            value='intervalo'
            label='Intervalo de datas'
            checked={useDateInterval}
            onChange={handleToggleDateInterval}
          />
        </div>

        {useDateInterval && (
          <div className={style.infoGrid}>
            <div className={style.formControl}>
              <Input
                type='date'
                max={today}
                label='Data início'
                id='data_inicio'
                value={formatDateToInputValue(watch('coverageProcess.dataInicio'))}
                error={errors?.coverageProcess?.dataInicio?.message}
                onChange={(value: string) => {
                  if (validateDateNotFuture(value, 'coverageProcess.dataInicio', 'Data início')) {
                    clearErrors('coverageProcess.dataInicio')
                  }
                  setValue('coverageProcess.dataInicio', value, { shouldDirty: true })
                }}
              />
            </div>
            <div className={style.formControl}>
              <Input
                type='date'
                max={today}
                label='Data final'
                id='data_final'
                value={formatDateToInputValue(watch('coverageProcess.dataFim'))}
                error={errors?.coverageProcess?.dataFim?.message}
                onChange={(value: string) => {
                  if (validateDateNotFuture(value, 'coverageProcess.dataFim', 'Data final')) {
                    clearErrors('coverageProcess.dataFim')
                  }
                  setValue('coverageProcess.dataFim', value, { shouldDirty: true })
                }}
              />
            </div>
          </div>
        )}

        <div className={style.formControl}>
          <SelectAnimalFetchInput
            label='Touro'
            selectBy='id'
            showBy={['cdn', 'nome']}
            // hidden={['MT', 'VD']}
            value={watch('pregnancyDiagnosis.touro') || ''}
            error={errors?.pregnancyDiagnosis?.touro?.message}
            placeholder='Selecionar Touro'
            onChange={(item: FormattedOption) => {
              setValue('pregnancyDiagnosis.touro', item.id, { shouldDirty: true })
              clearErrors('pregnancyDiagnosis.touro')
            }}
          />
        </div>
      </div>
    </section>
  )
}
